import { ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

interface UsageRowProps {
  id: string;
  name: string;
  usage: number;
  total: number;
  onClick: () => void;
  gradientColors?: string;
}

export const UsageRow = ({
  id,
  name,
  usage,
  total,
  onClick,
  gradientColors = 'from-blue-300 via-blue-400 to-blue-600 dark:from-blue-400 dark:via-blue-500 dark:to-blue-600',
}: UsageRowProps) => {
  const percent =
    total > 0 ? Math.max(0, Math.min(100, (usage / total) * 100)) : 0;
  return (
    <div
      key={id}
      onClick={onClick}
      className="flex w-full min-w-0 items-end gap-3 hover:cursor-pointer hover:bg-accent/40 rounded-md"
    >
      {/* Left column */}
      <div className="flex-1 min-w-0">
        <div className="truncate text-sm font-medium text-foreground">
          {name}
        </div>

        <div className="mt-1 flex items-center gap-3 min-w-0">
          {/* Track */}
          <div className="relative h-3 flex-1 min-w-0 rounded-full bg-muted overflow-hidden">
            {/* Fill */}
            <div
              className={cn(
                'h-full rounded-full bg-gradient-to-r',
                gradientColors
              )}
              style={{ width: `${percent}%` }}
            />
          </div>
        </div>
      </div>

      {/* Right column (always visible) */}
      <div className="flex shrink-0 items-center gap-2">
        <div className="w-6 text-right text-xs font-semibold text-foreground">
          {usage}
        </div>
        <ChevronRight className="h-4 w-4 text-muted-foreground" />
      </div>
    </div>
  );
};
